export default __webpack_public_path__ + "static/media/go-back.cb861ef5.svg";